import './src/lib/logbox';
import 'expo-router/entry';

globalThis.__TABBIO_WEB_ENTRY_VERSION__ = '2026-05-07-safari-entry';
